export const verifyConstants = {

  /*********
   초기화
   **********/
  VERIFY_INIT: 'VERIFY_INIT',

  /*********
   증명서 진본검증
   **********/
  VERIFY_REQUEST: 'VERIFY_REQUEST',
  VERIFY_SUCCESS: 'VERIFY_SUCCESS',
  VERIFY_FAILURE: 'VERIFY_FAILURE',

  /*********
   증명서 목록
   **********/
  VERIFY_SENT : 'VERIFY_SENT',
  VERIFY_INBOX : 'VERIFY_INBOX',
  VERIFY_LIST_REQUEST: 'VERIFY_LIST_REQUEST',
  VERIFY_LIST_SENT_SUCCESS: 'VERIFY_LIST_SENT_SUCCESS',
  VERIFY_LIST_INBOX_SUCCESS: 'VERIFY_LIST_INBOX_SUCCESS',
  VERIFY_LIST_FAILURE: 'VERIFY_LIST_FAILURE',
}